// src/config/api.config.js
export const API_URL = process.env.REACT_APP_API_URL;

export const getAuthHeader = () => {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const setToken = (token, remember = false) => {
  sessionStorage.setItem("token", token);

  if (remember) {
    localStorage.setItem("token", token);
  }
};

export const clearToken = () => {
  sessionStorage.removeItem("token");
  localStorage.removeItem("token");
};

export const getToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};
